import { render, staticRenderFns } from "./DdNumberPlate.vue?vue&type=template&id=346ab0ff&scoped=true&"
import script from "./DdNumberPlate.vue?vue&type=script&lang=js&"
export * from "./DdNumberPlate.vue?vue&type=script&lang=js&"
import style0 from "./DdNumberPlate.vue?vue&type=style&index=0&id=346ab0ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ab0ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
